import { Directive, Input, OnInit, Injector } from '@angular/core';
import { InputDateMask } from '../components/form-input/form-input.model';
import { NgControl } from '@angular/forms';
import * as moment from 'moment';

@Directive({
  selector: '[gioDateMask]'
})
export class GioDateMaskDirective implements OnInit {
  @Input() gioDateMask: InputDateMask;
  private control: NgControl;
  private _lastMaskedValue = '';
  private _lastOriginalValue = '';
  constructor(
    private injector: Injector
  ) { }
  ngOnInit() {
    this.control = this.injector.get(NgControl);
    if (!this.control || !this.control.valueAccessor) {
      return;
    }

    const originalWriteVal = this.control.valueAccessor.writeValue.bind(this.control.valueAccessor);
    this.control.valueAccessor.writeValue = (val: any) => originalWriteVal(this._maskValue(val));

    this._setVal(this._maskValue(this.control.value));
  }

  private _maskValue(val: string): string {
    if (!this.gioDateMask || val === this._lastMaskedValue) {
      return val;
    }

    let maskedVal = '';
    if (val) {
      const date = moment(val);
      if (this.gioDateMask.timezone) {
        date.tz(this.gioDateMask.timezone);
      }
      maskedVal = date.format(this.gioDateMask.format);
    }

    return maskedVal;
  }

  private _unmaskValue(val: string): string {
    const maskedVal = this._maskValue(val);
    return val;
    // const unmaskedVal = unmaskValue(maskedVal);

    // if (maskedVal !== val) {
    //   this._setVal(maskedVal);
    // }

    // return maskedVal ? unmaskedVal : '';
  }

  private _setVal(val: string) {
    if (this.control.control) {
      this.control.control.setValue(val, { emitEvent: false });
    }
  }
}
